/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentRedactionAccessUpdate } from '../models/DocumentRedactionAccessUpdate';
import type { DocumentRedactionActivateRequest } from '../models/DocumentRedactionActivateRequest';
import type { DocumentRedactionContentUpdate } from '../models/DocumentRedactionContentUpdate';
import type { DocumentRedactionDraftCreate } from '../models/DocumentRedactionDraftCreate';
import type { DocumentRedactionResolveRequest } from '../models/DocumentRedactionResolveRequest';
import type { DocumentRedactionResponse } from '../models/DocumentRedactionResponse';
import type { DocumentTextSave } from '../models/DocumentTextSave';
import type { DocumentThread } from '../models/DocumentThread';
import type { DocumentVersion } from '../models/DocumentVersion';
import type { DocumentVersionCreate } from '../models/DocumentVersionCreate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentService {

    /**
     * List Versions
     * @param documentId
     * @returns DocumentVersion Successful Response
     * @throws ApiError
     */
    public static listVersionsApiV1DocumentDocumentIdVersionsGet(
        documentId: string,
    ): CancelablePromise<Array<DocumentVersion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/document/{document_id}/versions',
            path: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Version
     * @param documentId
     * @param requestBody
     * @returns DocumentVersion Successful Response
     * @throws ApiError
     */
    public static createVersionApiV1DocumentDocumentIdVersionsPost(
        documentId: string,
        requestBody: DocumentVersionCreate,
    ): CancelablePromise<DocumentVersion> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/versions',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rollback Version
     * @param documentId
     * @param versionId
     * @returns DocumentVersion Successful Response
     * @throws ApiError
     */
    public static rollbackVersionApiV1DocumentDocumentIdVersionsVersionIdRollbackPost(
        documentId: string,
        versionId: string,
    ): CancelablePromise<DocumentVersion> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/versions/{version_id}/rollback',
            path: {
                'document_id': documentId,
                'version_id': versionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Threads
     * @param documentId
     * @returns DocumentThread Successful Response
     * @throws ApiError
     */
    public static getThreadsApiV1DocumentDocumentIdThreadsGet(
        documentId: string,
    ): CancelablePromise<Array<DocumentThread>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/document/{document_id}/threads',
            path: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Redaction Draft
     * @param documentId
     * @param requestBody
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static createRedactionDraftApiV1DocumentDocumentIdRedactionsDraftPost(
        documentId: string,
        requestBody: DocumentRedactionDraftCreate,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/redactions/draft',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Activate Redaction Draft
     * @param documentId
     * @param redactionId
     * @param requestBody
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static activateRedactionDraftApiV1DocumentDocumentIdRedactionsRedactionIdActivatePost(
        documentId: string,
        redactionId: string,
        requestBody: DocumentRedactionActivateRequest,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/redactions/{redaction_id}/activate',
            path: {
                'document_id': documentId,
                'redaction_id': redactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Resolve Redactions
     * @param documentId
     * @param requestBody
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static resolveRedactionsApiV1DocumentDocumentIdRedactionsResolvePost(
        documentId: string,
        requestBody: DocumentRedactionResolveRequest,
    ): CancelablePromise<Array<DocumentRedactionResponse>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/redactions/resolve',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Redaction Access
     * @param documentId
     * @param redactionId
     * @param requestBody
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static updateRedactionAccessApiV1DocumentDocumentIdRedactionsRedactionIdAccessPatch(
        documentId: string,
        redactionId: string,
        requestBody: DocumentRedactionAccessUpdate,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/document/{document_id}/redactions/{redaction_id}/access',
            path: {
                'document_id': documentId,
                'redaction_id': redactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Redaction Content
     * @param documentId
     * @param redactionId
     * @param requestBody
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static updateRedactionContentApiV1DocumentDocumentIdRedactionsRedactionIdContentPatch(
        documentId: string,
        redactionId: string,
        requestBody: DocumentRedactionContentUpdate,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/document/{document_id}/redactions/{redaction_id}/content',
            path: {
                'document_id': documentId,
                'redaction_id': redactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Begin Redaction Removal
     * @param documentId
     * @param redactionId
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static beginRedactionRemovalApiV1DocumentDocumentIdRedactionsRedactionIdBeginRemovalPost(
        documentId: string,
        redactionId: string,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/redactions/{redaction_id}/begin-removal',
            path: {
                'document_id': documentId,
                'redaction_id': redactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Finalize Redaction Removal
     * @param documentId
     * @param redactionId
     * @returns DocumentRedactionResponse Successful Response
     * @throws ApiError
     */
    public static finalizeRedactionRemovalApiV1DocumentDocumentIdRedactionsRedactionIdFinalizeRemovalPost(
        documentId: string,
        redactionId: string,
    ): CancelablePromise<DocumentRedactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/document/{document_id}/redactions/{redaction_id}/finalize-removal',
            path: {
                'document_id': documentId,
                'redaction_id': redactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Document Binary
     * @param id
     * @returns binary Binary Yjs document data. Can be a document version ID or a document ID
     * @throws ApiError
     */
    public static getDocumentBinaryApiV1DocumentIdBinaryGet(
        id: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/document/{id}/binary',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Document Markdown
     * @param documentId
     * @returns string Markdown export generated from the live document state
     * @throws ApiError
     */
    public static getDocumentMarkdownApiV1DocumentDocumentIdMarkdownGet(
        documentId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/document/{document_id}/markdown',
            path: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Document Binary
     * Save Y.js binary document data.
     * Content-Type should be 'application/octet-stream'
     * @param documentId
     * @param requestBody
     * @returns any Binary document data saved successfully
     * @throws ApiError
     */
    public static saveDocumentBinaryApiV1DocumentDocumentIdBinaryPut(
        documentId: string,
        requestBody: Blob,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/document/{document_id}/binary',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/octet-stream',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Document Text
     * Save extracted text content for a document.
     * @param documentId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static saveDocumentTextApiV1DocumentDocumentIdTextPut(
        documentId: string,
        requestBody: DocumentTextSave,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/document/{document_id}/text',
            path: {
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
